import { AnyAction } from 'redux';
import { Injectable } from '@angular/core';
import { Produktlinie } from '@ps20-frontend/frontend-models';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { AnzahlTiereEnum } from './reducers/versicherungsnehmer.reducer';
import { AntragsummerGenerated } from './actiontypes/antragsummerGenerated';
export interface ThhHundAction<T = undefined> extends AnyAction {
  payload?: T;
}

export interface RasseMehrereHundeChangedPayload {
  rasse: string;
  index: number;
}

@Injectable()
export class ThhHundActions {
  static readonly ZURUECK_ZUM_SHOP_MODAL_OPEN = 'THH_HUND_ZURUECK_ZUM_SHOP_MODAL_OPEN';
  static readonly ZURUECK_ZUM_SHOP_MODAL_CLOSE = 'THH_HUND_ZURUECK_ZUM_SHOP_MODAL_CLOSE';
  static readonly PLZ_CHANGED = 'THH_HUND_PLZ_CHANGED';
  static readonly ORT_CHANGED = 'THH_HUND_ORT_CHANGED';
  static readonly STRASSE_CHANGED = 'THH_HUND_STRASSE_CHANGED';
  static readonly HAUSNUMMER_CHANGED = 'THH_HUND_HAUSNUMMER_CHANGED';
  static readonly GEBURTSDATUM_CHANGED = 'THH_HUND_GEBURTSDATUM_CHANGED';
  static readonly QUOTEDB_REQUESTED = 'THH_HUND_QUOTEDB_REQUESTED';
  static readonly PREISE_REQUESTED = 'THH_HUND_PREISE_REQUESTED';
  static readonly ZUM_ANGEBOT_BUTTON_CLICKED = 'THH_HUND_ZUM_ANGEBOT_BUTTON_CLICKED';
  static readonly ANZAHL_TIERE_CHANGED = 'THH_HUND_ANZAHL_TIERE_CHANGED';
  static readonly RASSE_EIN_HUND_CHANGED = 'THH_HUND_RASSE_EIN_HUND_CHANGED';
  static readonly VORSCHAEDEN_VORHANDEN = 'THH_HUND_VORSCHAEDEN_VORHANDEN';
  static readonly VORSCHADEN_VALUE_CHANGED = 'THH_HUND_VORSCHADEN_VALUE_CHANGED';

  static readonly ANZAHL_MEHRERE_HUNDE_CHANGED = 'THH_HUND_ANZAHL_MEHRERE_HUNDE_CHANGED';
  static readonly RASSE_MEHRERE_HUNDE_CHANGED = 'THH_HUND_RASSE_MEHRERE_HUNDE_CHANGED';
  static readonly SELBSTBETEILIGUNG_CHANGED = 'THH_HUND_SELBSTBETEILIGUNG_CHANGED';

  static readonly BRUTTOPREISE_CALCULATED = 'BRUTTOPREISE_CALCULATED';
  static readonly PRODUKTLINIEN_CHANGED = 'PRODUKTLINIEN_CHANGED';
  static readonly ABSPRUNG_INS_DASHBOARD = 'ABSPRUNG_INS_DASHBOARD';
  static readonly VORSCHLAGDATEN_CHANGED = 'VORSCHLAGDATEN_CHANGED';
  static readonly VERSICHERUNGSSUMME_CHANGED = 'VERSICHERUNGSSUMME_CHANGED';
  static readonly ANTRAGSNUMMER_GENERATED = 'ANTRAGSNUMMER_GENERATED';
  static readonly VORBELEGUNG_FINISHED = 'THH_HUND_VORBELEGUNG_FINISHED';
  static readonly HANDLE_THH_HUND_NAVIGATION_TO_ANGEBOT = 'HANDLE_THH_HUND_NAVIGATION_TO_ANGEBOT';

  zurueckZumShopModalOpen(): ThhHundAction {
    return { type: ThhHundActions.ZURUECK_ZUM_SHOP_MODAL_OPEN };
  }

  zurueckZumShopModalClose(): ThhHundAction {
    return { type: ThhHundActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE };
  }

  plzChanged(changedPlz: string): ThhHundAction<string> {
    return { type: ThhHundActions.PLZ_CHANGED, payload: changedPlz };
  }

  ortChanged(changedOrt: string): ThhHundAction<string> {
    return { type: ThhHundActions.ORT_CHANGED, payload: changedOrt };
  }

  strasseChanged(changedStrasse: string): ThhHundAction<string> {
    return { type: ThhHundActions.STRASSE_CHANGED, payload: changedStrasse };
  }

  hausnummerChanged(changedHausnummer: string): ThhHundAction<string> {
    return {
      type: ThhHundActions.HAUSNUMMER_CHANGED,
      payload: changedHausnummer,
    };
  }

  geburtsdatumChanged(geburtsdatum: string): ThhHundAction<string> {
    return { type: ThhHundActions.GEBURTSDATUM_CHANGED, payload: geburtsdatum };
  }

  quoteDBRequested(): ThhHundAction {
    return { type: ThhHundActions.QUOTEDB_REQUESTED };
  }

  preiseRequested(): ThhHundAction {
    return { type: ThhHundActions.PREISE_REQUESTED };
  }

  zumAngebotButtonClicked(): ThhHundAction {
    return { type: ThhHundActions.ZUM_ANGEBOT_BUTTON_CLICKED };
  }

  anzahlTiereChanged(anzahlTiere: AnzahlTiereEnum): ThhHundAction<AnzahlTiereEnum> {
    return { type: ThhHundActions.ANZAHL_TIERE_CHANGED, payload: anzahlTiere };
  }

  rasseEinHundChanged(rasseValue: string): ThhHundAction<string> {
    return { type: ThhHundActions.RASSE_EIN_HUND_CHANGED, payload: rasseValue };
  }

  vorschaedenVorhandenChanged(vorhanden: boolean): ThhHundAction<boolean> {
    return { type: ThhHundActions.VORSCHAEDEN_VORHANDEN, payload: vorhanden };
  }

  vorschadenValueChanged(
    vorschadenId: string,
    value: number,
  ): ThhHundAction<{ vorschadenId: string; value: number }> {
    return {
      type: ThhHundActions.VORSCHADEN_VALUE_CHANGED,
      payload: { vorschadenId, value },
    };
  }

  anzahlMehrereHundeChanged(anzahl: number): ThhHundAction<number> {
    return {
      type: ThhHundActions.ANZAHL_MEHRERE_HUNDE_CHANGED,
      payload: anzahl,
    };
  }

  rasseMehrereHundeChanged(
    rasse: string,
    index: number,
  ): ThhHundAction<RasseMehrereHundeChangedPayload> {
    return {
      type: ThhHundActions.RASSE_MEHRERE_HUNDE_CHANGED,
      payload: { rasse: rasse, index: index },
    };
  }

  selbstbeteiligungChanged(selbstbeteiligung: Selbstbeteiligung): ThhHundAction<Selbstbeteiligung> {
    return {
      type: ThhHundActions.SELBSTBETEILIGUNG_CHANGED,
      payload: selbstbeteiligung,
    };
  }

  bruttopreiseCalculated(
    produktlinienMitBruttopreisen: Array<Produktlinie>,
  ): ThhHundAction<Array<Produktlinie>> {
    return {
      type: ThhHundActions.BRUTTOPREISE_CALCULATED,
      payload: produktlinienMitBruttopreisen,
    };
  }

  tarifChecked(index: number): ThhHundAction<{ index: number }> {
    return { type: TARIF_CHECKED, payload: { index } };
  }

  produktlinienChanged(produktlinien: Produktlinie[]): ThhHundAction<Produktlinie[]> {
    return {
      type: ThhHundActions.PRODUKTLINIEN_CHANGED,
      payload: produktlinien,
    };
  }

  absprungInsDashboard(): ThhHundAction {
    return { type: ThhHundActions.ABSPRUNG_INS_DASHBOARD };
  }

  vorschlagdatenChanged(deferTarifierung = false): AnyAction {
    return deferTarifierung
      ? { type: ThhHundActions.VORSCHLAGDATEN_CHANGED, payload: { deferTarifierung } }
      : { type: ThhHundActions.VORSCHLAGDATEN_CHANGED };
  }

  versicherungsSummeChanged(
    versSummeLeistung: number,
  ): ThhHundAction<{ versSummeLeistung: number }> {
    return {
      type: ThhHundActions.VERSICHERUNGSSUMME_CHANGED,
      payload: { versSummeLeistung },
    };
  }

  antragsnummerGenerated(antragsnummer: string): ThhHundAction<AntragsummerGenerated> {
    return {
      type: ThhHundActions.ANTRAGSNUMMER_GENERATED,
      payload: { antragsnummer },
    };
  }

  handleThhHundNavigationToAngebot(): ThhHundAction {
    return { type: ThhHundActions.HANDLE_THH_HUND_NAVIGATION_TO_ANGEBOT };
  }
}
